import {BaseModel} from '../base.model';
import { ExerciseModel } from './exercise.model';
import { JsonProperty } from '../json-map.util';
import { ProblemProgressModel } from '../problem-progress/problem-progress.model';

class ExerciseRoundModel extends BaseModel  {
  exercise: ExerciseModel;
  exerciseProgressId: number;
  totalProblemCount: number;
  @JsonProperty({ clazz: ProblemProgressModel })
  previousProblemProgress = [];
}

export { ExerciseRoundModel };
